<script>
export default {
  name: "TheDesktopTopMenu",
  props: {
    menuItems: {
      type: Object,
      default: () => {
        return {
          topMenuItems: [],
          ctaMenuItems: []
        }
      }
    }
  }
}
</script>

<template>
  <div id="desktop-menu" class="d-none d-md-flex flex-row align-items-center justify-content-start text-white h-100">
    <button
       v-for="(menu, index) in menuItems.topMenuItems"
        :key="menu.menu_title_text"
        :id="`submenu${index+1}Button`" 
        :data-selector="`#offcanvasSubmenu${index+1}`" 
        class="desktop-menu-button text-uppercase"
        aria-expanded="false">
      {{ menu.menu_title_text }}
    </button>
    <a
        v-for="menu in menuItems.ctaMenuItems"
        :key="menu._metadata.uid"
        :href="menu.link.href"
        class="desktop-menu-callout d-none d-lg-inline-block ms-auto offcanvasNavbarLabel fs-5 text-center rounded-pill font-ck-heading fw-semibold text-uppercase">
      {{ menu.link.title }}
    </a>
  </div>
</template>
